import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Behandlinger from "./pages/Behandlinger";
import LigtornBehandling from "./pages/LigtornBehandling";
import OmMig from "./pages/OmMig";
import Kontakt from "./pages/Kontakt";

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-[#FAF8F5] antialiased selection:bg-[#E8EFEA] selection:text-[#2E4233]">
      {/* Håndterer scroll-restaurering ved sideskift */}
      <ScrollToTop />

      {/* Global Header */}
      <Header />

      {/* Hovedindhold */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/behandlinger" element={<Behandlinger />} />
          <Route path="/behandling-af-ligtorn" element={<LigtornBehandling />} />
          <Route path="/om-mig" element={<OmMig />} />
          <Route path="/kontakt" element={<Kontakt />} />
          {/* Fallback til forside ved ukendte ruter */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>

      {/* Global Footer */}
      <Footer />
    </div>
  );
}

export default App;
